import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import styles from './WithShimmerEffect.module.css'

interface WithShimmerEffectProps {
  children: ReactNode
  className?: string
  innerClassName?: string
}

export const WithShimmerEffect = ({children, className, innerClassName}: WithShimmerEffectProps) => {
  return (
    <div className={clsx(styles.fadeIn, className)}>
      <div className={clsx(styles.shimmerText, innerClassName)}>{children}</div>
    </div>
  )
}

try{ WithShimmerEffect.displayName ||= 'WithShimmerEffect' } catch {}